

precision highp float;

uniform mat4 modelViewMatrix;
uniform mat4 projectionMatrix;

in vec3 position;
in vec2 uv;

out vec2 rttCoord;

void main()	{
  rttCoord = uv;
  gl_Position = projectionMatrix * vec4(position,1.);
}